// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"5":"1e174d64","354":"1ac29d66","372":"3ec1deb0","379":"38cce688","605":"932db783","665":"99483cb3","731":"6e21d174","787":"faafaf2a","941":"c954b911","963":"502a127a"}[chunkId] + ".chunk.js";
};